import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M14.963 15.8a.9.9 0 0 0 .897-.9c0-.497-.402-.9-.897-.9a.9.9 0 0 0-.898.9c0 .497.402.9.898.9ZM9.963 11.8a.9.9 0 0 0 .897-.9c0-.497-.402-.9-.897-.9a.9.9 0 0 0-.898.9c0 .497.402.9.898.9Z"
      style={{
        fill: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M8.239 19.357c-1.454.34-2.762-.972-2.423-2.43.194-.825-.145-1.7-.871-2.137-1.26-.778-1.26-2.624 0-3.401.726-.437 1.065-1.312.871-2.138-.338-1.457.97-2.77 2.423-2.43.823.195 1.695-.145 2.131-.874.775-1.263 2.616-1.263 3.39 0 .437.73 1.309 1.07 2.132.875 1.454-.34 2.762.972 2.422 2.43-.193.825.146 1.7.872 2.137 1.26.777 1.26 2.623 0 3.4"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9.497 14.984c1.502-1.992 4.7-2.867 4.36-4.227"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const SaleIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
